export default {
  reports: {
    actions: {},
    dataTable: {
      headers: {
        modified: "Modified",
        name: "Name",
        tenant: "Tenant"
      },
      noResultsText: "No matching reports"
    },
    itemName: "report"
  }
}
